import { motion } from "framer-motion";
import { BadgeCheck, Heart, Sun, Flame, Sparkles } from "lucide-react";
import { REASONS } from "@/lib/site-data";

const ICONS = {
    BadgeCheck,
    Lotus: Sparkles,
    Candle: Flame,
    Heart,
    Sun,
};

export default function WhyUs() {
    return (
        <section
            id="why-us"
            data-testid="why-us-section"
            className="relative py-24 lg:py-36 marble-dark text-cream overflow-hidden"
        >
            {/* Decorative gold filigree */}
            <div className="absolute top-10 right-10 opacity-20 hidden lg:block">
                <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
                    <circle cx="100" cy="100" r="80" stroke="#C9A961" strokeWidth="0.5" />
                    <circle cx="100" cy="100" r="60" stroke="#C9A961" strokeWidth="0.5" />
                    <circle cx="100" cy="100" r="40" stroke="#C9A961" strokeWidth="0.5" />
                </svg>
            </div>

            <div className="relative max-w-7xl mx-auto px-5 lg:px-10">
                <div className="max-w-2xl mb-16 lg:mb-20">
                    <span className="eyebrow !text-gold-light flex items-center gap-3">
                        <span className="w-8 h-px bg-gold-light" />
                        Why Choose Us
                    </span>
                    <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
                        Five quiet reasons people{" "}
                        <em className="font-light text-gold-light">keep coming back.</em>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
                    {REASONS.map((r, i) => {
                        const Icon = ICONS[r.icon] || Sparkles;
                        return (
                            <motion.div
                                key={r.title}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.6, delay: i * 0.1 }}
                                className="border border-gold/25 hover:border-gold/70 transition-all p-6 lg:p-7 bg-maroon-deep/40 backdrop-blur-sm"
                                data-testid={`reason-${i}`}
                            >
                                <div className="w-12 h-12 flex items-center justify-center border border-gold/40 text-gold rounded-full mb-5">
                                    <Icon size={20} strokeWidth={1.4} />
                                </div>
                                <h3 className="font-serif text-xl lg:text-2xl text-cream leading-tight">
                                    {r.title}
                                </h3>
                                <p className="mt-3 text-sm text-cream/70 font-light leading-relaxed">
                                    {r.text}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
